import Vue from 'vue'
import Vuex from 'vuex'
import client from './modules/client'
import app from './modules/app'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    client,
    app,
  },
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/store/index.ts